export default __webpack_public_path__ + "static/media/accept_requests.1777e74d.png";